import '../../App.css';
import React, { useContext, useEffect, useCallback, useState } from 'react';
import { ApiContext } from "../../context/ApiContext";
import Header from '../../components/header/Header';
import MenuLateral from '../../components/menu/MenuLateral'
import Footer from '../../components/footer/Footer'
import { FaPlus } from 'react-icons/fa'
import { IoIosWarning, IoIosCheckmarkCircle } from "react-icons/io";
import { TbPencil, TbTrash } from "react-icons/tb";
import { StyleContext } from '../../context/StyleContext';
import ModalCadastrarPeriodicidade from '../../components/modal/ModalCadastrarPeriodicidade';
import ModalEditarPeriodicidade from '../../components/modal/ModalEditarPeriodicidade';
import ModalExcluirPeriodicidade from '../../components/modal/ModalExcluirPeriodicidade';
import { ServicoContext } from '../../context/ServicoContext';
import Tabela from '../../components/Tabela';

function Periodicidade() {
    const { Success, Error, openModal, setOpenModal, PeriodicidadesConsulta, ListaPeriodicidadeConsulta, loading, modalEditarPeriodicidade, setModalEditarPeriodicidade, setEdicaoPeriodicidade, setPeriodicidadeAtualKey, modalExcluirPeriodicidade, setModalExcluirPeriodicidade, InativarPeriodicidade, ListaFiltroPeriodicidade, totalRegistrosPeriodicidade, filtroPeriodicidade, totalRegistrosFiltroPeriodicidade } = useContext(ServicoContext)
    const { Permissao } = useContext(ApiContext)
    const { h3Demanda, btnCriar, corTerciaria } = useContext(StyleContext)

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");

    const EditPeriodicidade = (props) => {
        setModalEditarPeriodicidade(true)
        setPeriodicidadeAtualKey(props.key)
        setEdicaoPeriodicidade(props)
    }

    const DeletarPeriodicidade = (props) => {
        setPeriodicidadeAtualKey(props.key)
        setModalExcluirPeriodicidade(true)
    }

 useEffect(() => {
        if (searchTerm.trim() !== "") {
            ListaFiltroPeriodicidade(searchTerm, currentPage, pageSize);
        } else {
            ListaPeriodicidadeConsulta(currentPage, pageSize);
        }
    }, [currentPage, searchTerm]);

    const totalRegistros = searchTerm.trim() !== "" ? totalRegistrosFiltroPeriodicidade : totalRegistrosPeriodicidade;
    const totalPages = Math.max(1, Math.ceil((totalRegistros || 0) / pageSize));

    return (
        <div>
            <Header pagina={'Cadastros'} subpagina={'Cadastrar periodicidades'}></Header>
            <MenuLateral></MenuLateral>
            {modalEditarPeriodicidade &&
                <ModalEditarPeriodicidade currentPage={currentPage} />
            }
            {modalExcluirPeriodicidade &&
                <ModalExcluirPeriodicidade currentPage={currentPage} />
            }
            {Success &&
                <div className='success'>
                    <IoIosCheckmarkCircle className='error-icon' />{Success}
                </div>
            }
            {Error &&
                <div className='error'>
                    <IoIosWarning className='error-icon' />{Error}
                </div>
            }
            <div className='container-principal'>
                <div className='demanda-header'>
                    {openModal &&
                        <ModalCadastrarPeriodicidade closeModal={setOpenModal} currentPage={currentPage} />
                    }
                    {(!!Permissao.find(Periodicidade => Periodicidade.menu.descricao === "SERVICOS" && Periodicidade.edicao === true)) &&
                        <button className='btn-dash btn-criar' style={btnCriar} onClick={() => setOpenModal(true)}><FaPlus style={{ marginRight: "10px" }} />Cadastrar periodicidade</button>
                    }
                </div>
                {loading ? (
                    <div className="loading-screen">
                        <div className="loader-container">
                            <div className="spinner"></div>
                        </div>
                    </div>
                ) : (
                    <div className='card card-table'>
                        <h3 className='h3-demanda' style={h3Demanda}>Periodicidades cadastradas</h3>
                         <Tabela
                                                data={searchTerm.trim() !== "" ? filtroPeriodicidade : PeriodicidadesConsulta}
                                                columns={[
                                                    { label: "Periodicidade", field: "nome", width: "40%" },
                                                    { label: "Descrição", field: "descricao", width: "40%", render: (x) => x.descricao || "-" },
                                                    {
                                                        label: "Ativo",
                                                        width: "10%",
                                                        align: "center",
                                                        render: (x) => (
                                                            <div className="checkbox-wrapper" style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                                                                <input type="checkbox" label=" Ativo" className="toggleBtn" onChange={() => InativarPeriodicidade(x.key, !x.ativo)} checked={x.ativo} />
                                                            </div>
                                                        ),
                                                    },
                                                    {
                                                        label: "Opções",
                                                        width: "10%",
                                                        align: "center",
                                                        render: (x) => (
                                                            <div style={{ display: "flex", justifyContent: "center" }}>
                                                                <button onClick={() => EditPeriodicidade(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                                                    <TbPencil />
                                                                </button>
                                                                {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                                                                    <button onClick={() => DeletarPeriodicidade(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                                                        <TbTrash />
                                                                    </button>
                                                                }
                                                            </div>
                                                        ),
                                                    },
                                                ]}
                                                loading={loading}
                                                currentPage={currentPage}
                                                totalPages={totalPages}
                                                setCurrentPage={setCurrentPage}
                                                searchTerm={searchTerm}
                                                setSearchTerm={setSearchTerm}
                                                onSearch={(term) => {
                                                    setCurrentPage(1);
                                                    if (term.trim() !== "") {
                                                        ListaFiltroPeriodicidade(term, 1, 10);
                                                    } else {
                                                        ListaPeriodicidadeConsulta(1, 10);
                                                    }
                                                }}
                                                corTerciaria={corTerciaria}
                                            />
                    </div>
                )}
            </div>
            <Footer></Footer>
        </div>
    );
}

export default Periodicidade;